import { Icon, IconProps } from '@chakra-ui/react';

export default function CrossIcon(props: IconProps) {
  return (
    <Icon width="11px" height="11px" {...props}>
      <svg width="11" height="11" viewBox="0 0 11 11" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1 10L10 1"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1 1L10 10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
}
